"use strict";

require("core-js/modules/es6.string.link");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var breakpoints_1 = require("./breakpoints");

var colors_1 = require("./colors");

exports.Color = colors_1.Color;
exports.RGB = colors_1.RGB;

var typography_1 = require("./typography");

var link_1 = require("./link");

var spacing_1 = require("./spacing");

var button_1 = require("./button");

var palette_1 = require("./palette");

var shape_1 = require("./shape");

var zIndex_1 = require("./zIndex");

exports.DefaultVarnishTheme = {
  breakpoints: breakpoints_1.breakpoints,
  color: colors_1.color,
  chartingColor: colors_1.chartingColor,
  palette: palette_1.palette,
  typography: typography_1.typography,
  link: link_1.link,
  shape: shape_1.shape,
  spacing: spacing_1.spacing,
  button: button_1.button,
  zIndex: zIndex_1.zIndex // when adding more, consider what material and ant have done:
  // https://material-ui.com/customization/default-theme/
  // https://github.com/ant-design/ant-design/blob/master/components/style/themes/default.less

};